module.exports = __webpack_public_path__ + "static/media/smoke-takeoff.8ccbff0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/starPods/smoke-takeoff.svg
// module id = 2697
// module chunks = 0